import React from 'react';
import { X } from 'lucide-react';

const CorrectiveActionForm = ({ 
  action, 
  idx, 
  committeeMembers, 
  correctiveActions, 
  setCorrectiveActions 
}) => {
  const updateActionField = (id, field, value) => {
    const updated = correctiveActions.map(a =>
      a.id === id ? { ...a, [field]: value } : a
    );
    setCorrectiveActions(updated);
  };

  return (
    <div className="corrective-action-card">
      <div className="corrective-action-header">
        <h4 className="corrective-action-title">Corrective Action {idx + 1}</h4>
        <button
          onClick={() => setCorrectiveActions(
            correctiveActions.filter(a => a.id !== action.id)
          )}
          className="btn-remove"
        >
          <X className="icon-sm" />
        </button>
      </div>
      <div className="corrective-action-grid">
        <div className="form-group">
          <label className="form-label-sm">Description</label>
          <textarea
            placeholder="Describe the corrective action..."
            className="form-textarea"
            rows="2"
            value={action.description || ''}
            onChange={(e) => updateActionField(action.id, 'description', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-label-sm">Assigned To</label>
          <select
            className="form-select form-select-sm"
            value={action.assignedTo || ''}
            onChange={(e) => updateActionField(action.id, 'assignedTo', e.target.value)}
          >
            <option value="">Select person</option>
            {committeeMembers.map(member => (
              <option key={member.id} value={member.email || member.id}>{member.name}</option>
            ))}
          </select>
          <label className="form-label-sm mt-2">Target Date</label>
          <input
            type="date"
            className="form-input form-input-sm"
            value={action.targetDate || ''}
            onChange={(e) => updateActionField(action.id, 'targetDate', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default CorrectiveActionForm;